import React from 'react';
import { Box, Copy, Optional } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';
import formatPrice from '@honda-canada/js-utilities/lib/formatPrice';
import themeStyles from './DueAtDelivery.styles';
import { useFetchCurrentVehicleFinancialCalculatorSummary } from '../../core/apiHooks/useFetchSummary';
import { useLanguage } from '../../utils/sitecoreContext';
const Wrapper = themeStyles.apply(Box, 'DueAtDeliveryWrapper');
const PriceCopy = themeStyles.apply(Copy, 'PriceCopy');
const DueAtDelivery = ({ calculatorId, isCompareSection }) => {
    const { t } = useTranslation();
    const language = useLanguage();
    const DueAtDeliveryLabel = t('Pages.Bap.dueAtDeliveryLabel');
    const { summary, isFetching, isLoading, error } = useFetchCurrentVehicleFinancialCalculatorSummary(calculatorId);
    const findDueAtDeliveryObject = (summaryItems, keys) => summaryItems === null || summaryItems === void 0 ? void 0 : summaryItems.find(item => keys.includes(item.key));
    const keysToCheck = ['DueUponDeliveryGroup', 'AmountDueOnDeliveryGroup'];
    const dueAtDeliveryObject = findDueAtDeliveryObject(summary, keysToCheck);
    const valueDueAtDelivery = dueAtDeliveryObject === null || dueAtDeliveryObject === void 0 ? void 0 : dueAtDeliveryObject.value;
    const dueAtDeliveryIsUnavailable = !dueAtDeliveryObject || isFetching || isLoading || error;
    return (React.createElement(Optional, { when: !dueAtDeliveryIsUnavailable },
        React.createElement(Wrapper, { isCompareSection: isCompareSection, "data-testid": "cy-due-at-delivery-wrapper" },
            React.createElement(Copy, { size: "small", "data-testid": "cy-due-at-delivery-label" }, DueAtDeliveryLabel),
            React.createElement(PriceCopy, { size: "small", "data-testid": "cy-due-at-delivery-price" }, formatPrice(valueDueAtDelivery, language, 2)))));
};
export default DueAtDelivery;
